module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Arm Sofa_Stone.04e77c08.png";